<template>
  <div class="form-row ">
    <div class="form-label">{{ info.displayName }}</div>
    <div
      class="form-contro pull-relative"
      :class="{ 'embed-file': info.fileLimitType !== 'IMG' }"
    >
      <van-uploader
        v-if="info.fileLimitType === 'IMG'"
        :after-read="afterChange"
        :before-read="beforeRead"
        :accept="info.accept"
        :disabled="info.disabled"
      >
        <div class="avatar-img">
          <span class="icon icontemp avatar" v-if="!info.value"></span>
          <img
            :src="info.value.newPath || info.fileUrl + info.value.mappingId"
            v-if="info.value"
          />
        </div>
      </van-uploader>

      <div
        class="form-group"
        style="position: relative"
        :class="{ 'show-btns': info.value }"
        v-if="info.fileLimitType !== 'IMG'"
      >
        <input
          type="text"
          class="form-input"
          :value="info.value ? info.value.fileName : ''"
          readonly
          :disabled="info.disabled"
        />
        <button class="form-btn save">
          {{ info.isUpload ? "上传中" : "上传文件" }}
        </button>
        <input
          type="file"
          style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; opacity: 0;"
          :disabled="info.disabled || info.isUpload"
          :ref="info.fieldName"
          @change="fileChange($event)"
          :accept="info.accept"
        />
      </div>
      <div
        v-if="info.fileLimitType === 'IMG' && !info.disabled"
        class="imgage-btns"
        :class="{ 'align-right': info.fileLimitType !== 'IMG' && info.value }"
      >
        <button
          class="form-btn cancel"
          v-if="info.value"
          @click="info.clearValue()"
          :disabled="info.disabled"
        >
          移除
        </button>
      </div>
      <div
        v-if="info.fileLimitType !== 'IMG' && !info.disabled"
        class="imgage-btns"
        :class="{ 'align-right': info.fileLimitType !== 'IMG' && info.value }"
      >
        <button
          class="form-btn cancel"
          v-if="info.value"
          @click="clearValue()"
          :disabled="info.disabled"
        >
          移除
        </button>
      </div>
    </div>
    <div class="form-error" v-if="info.dirty && info.invalid">
      {{ info.validationMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: "SFile",
  props: {
    info: {}
  },
  data() {
    return {};
  },
  methods: {
    clearValue() {
      this.$refs[this.info.fieldName].value = "";
      this.info.clearValue();
    },
    fileChange(ev) {
      if (ev.target.files && ev.target.files.length > 0) {
        this.info.isFormatAndSize(ev.target.files[0]);
        this.info.upload({
          file: ev.target.files[0]
        });
      }
    },
    afterChange(e) {
      this.info.isFormatAndSize(e.file);
      this.info.upload({
        file: e.file
      });
    },
    beforeRead() {
      return true;
    }
  }
};
</script>

<style scoped></style>
